import {Injector, Pipe} from '@angular/core';

@Pipe({
  name: 'daysDiff'
})
export class DaysDiffPipe {

  public constructor(private injector: Injector) {
  }

  private static calculateDiff(dateSentString?: string): number {
    const currentDate = new Date();
    const dateSent = new Date(dateSentString);

    return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate()) ) / (1000 * 60 * 60 * 24));
  }

  transform(value: any): any {
    if (!value) {
      return '';
    }

    return DaysDiffPipe.calculateDiff(value) * -1;
  }

}
